// quick-filter-state.service.ts - Simplified version
import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QuickFilterStateService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private readonly STORAGE_KEY = 'leads-quick-filters';
  private readonly PIPELINE_STORAGE_KEY = 'pipeline-quick-filters';
  private isInLeadsModule = false;

  constructor(private router: Router) {
    this.initializeRouterListener();
    this.isInLeadsModule = this.router.url.includes('/leads');
  }

  private initializeRouterListener(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        const wasInLeadsModule = this.isInLeadsModule;
        this.isInLeadsModule = event.url.includes('/leads');

        // Clear when leaving leads module
        if (wasInLeadsModule && !this.isInLeadsModule) {
          this.clearQuickFilters('all');
        }
      });
  }

  saveLeadsQuickFilters(filters: any[]): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filters));
  }

  savePipelineQuickFilters(filters: any[]): void {
    localStorage.setItem(this.PIPELINE_STORAGE_KEY, JSON.stringify(filters));
  }

  getLeadsQuickFilters(): any[] {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  getPipelineQuickFilters(): any[] {
    try {
      const stored = localStorage.getItem(this.PIPELINE_STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  clearQuickFilters(type: 'leads' | 'pipeline' | 'all' = 'all'): void {
    if (type === 'leads' || type === 'all') {
      localStorage.removeItem(this.STORAGE_KEY);
    }
    if (type === 'pipeline' || type === 'all') {
      localStorage.removeItem(this.PIPELINE_STORAGE_KEY);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}